import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { TextareaAutosize } from '@mui/material'
import { useAppServices } from 'hook/services'
import MDInput from 'components/MDInput'
import Multiselect from '../../MultiSelect'
import { Roles } from 'enums/user'
import { useAgencyInfo } from 'context/agency'

const CreateModal = ({ editData, handleRefresh }) => {
  const [agency] = useAgencyInfo()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [staffData, setStaffData] = useState([])
  const [ghlFeatures, setGhlFeatures] = useState([])
  const [team, setTeam] = useState([])
  const [tags, setTags] = useState([])

  const getTags = async () => {
    const { response } = await AppService.team_tags.get({
      toaster: false,
    })
    if (response) {
      setTags(response.data)
    } else {
      setTags([])
    }
    // setLoader(false)
  }

  const getGhlFeatures = async () => {
    const { response } = await AppService.ghl_features.get({
      toaster: false,
    })
    if (response) {
      setGhlFeatures(response.data)
    } else {
      setGhlFeatures([])
    }
    // setLoader(false)
  }

  const getStaff = async () => {
    const { response } = await AppService.user.GetUsers()
    if (response) {
      setStaffData(response.data)
    } else {
      setStaffData([])
    }
    // setLoader(false)
  }
  const getTEam = async () => {
    const { response } = await AppService.team.get({})
    if (response) {
      setTeam(response.data)
    } else {
      setTeam([])
    }
    // setLoader(false)
  }
  const tagsOptions = tags?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))
  const ghlfeaturesOptions = ghlFeatures?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))
  const teamOptions = team?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))
  const staffOptions = staffData?.map(item => ({
    label: item?.username,
    value: item?._id,
  }))
  useEffect(() => {
    getTags()
    getStaff()
    getTEam()
    getGhlFeatures()
  }, []);

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  useEffect(() => { }, [])

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      const payload = {
        _id: editData._id,
        name: e.target.name.value,
        description: e.target.description.value,
        points: e.target.points.value,
        staff_team: e.target.staff_team ? JSON.parse(e.target.staff_team.value) : [],
        team: e.target.team ? JSON.parse(e.target.team.value) : [],
        staff_tag: e.target.staff_tag ? JSON.parse(e.target.staff_tag.value) : [],
        ghl_features: e.target.ghl_features ? JSON.parse(e.target.ghl_features.value) : [],
      }

      const { response } = await AppService.staff_job.update({
        payload: payload,
      })

      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      p: 4,
    }

    return (
      <MDModal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Edit Staff Tag
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Tag Title
              </MDTypography>
              <MDInput label="Staff Tag" name="name" fullWidth defaultValue={editData?.name} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <TextareaAutosize type="text" name="description" minRows={3} style={{ width: '100%' }} defaultValue={editData?.description} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Points
              </MDTypography>
              <MDInput label="Points" name="points" fullWidth defaultValue={editData?.points} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Tags
              </MDTypography>
              <Multiselect data={tagsOptions} isMulti={true} name="staff_tag" defaultValue={editData?.staff_tag} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Ghl Features
              </MDTypography>
              <Multiselect data={ghlfeaturesOptions} isMulti={true} name="ghl_features" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Staff
              </MDTypography>
              <Multiselect data={staffOptions} isMulti={true} name="staff_team" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Team
              </MDTypography>
              <Multiselect data={teamOptions} isMulti={true} name="team" />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="primary" type="button" sx={{ mt: 4, mb: 1 }} onClick={onClose}>
                Close
              </MDButton>
              <MDButton variant="gradient" color="info" type="submit" sx={{ mt: 4, mb: 1, ml: 1 }} loading={processing} disabled={processing}>
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton variant="contained" color="warning" size="small" onClick={handlemodal}>
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={() => setOpenAddProduct(false)} />
    </>
  )
}

export default CreateModal
